"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "qrcode-container"
  }, [_c("div", {
    staticClass: "absolute flex items-center gap-[10px] top-[26px] right-[34px] pointer"
  }, [_c("a-icon", {
    attrs: {
      type: "rollback"
    }
  }), _c("p", {
    on: {
      click: function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("返回")])], 1), _c("canvas", {
    ref: "qrcodeCanvas"
  }), _c("a-button", {
    staticClass: "mt-[30px] w-[400px] h-[80px] rounded-[10px] text-[20px]",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleCopy
    }
  }, [_vm._v(" 复制链接分享 ")])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;